module.exports = __webpack_public_path__ + "img/img_throw_4@3x_v2.e02dfe4f.png";